/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ targetText: NonNullable<unknown> }} Exercise_Personal_Goal_Progress_LabelInputs */

const en_us2_exercise_personal_goal_progress_label = /** @type {(inputs: Exercise_Personal_Goal_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Progress toward ${i?.targetText}`)
};

const pt_br2_exercise_personal_goal_progress_label = /** @type {(inputs: Exercise_Personal_Goal_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Progresso até ${i?.targetText}`)
};

const es_419_exercise_personal_goal_progress_label = /** @type {(inputs: Exercise_Personal_Goal_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Progreso hacia ${i?.targetText}`)
};

const pt_pt2_exercise_personal_goal_progress_label = /** @type {(inputs: Exercise_Personal_Goal_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Progresso até ${i?.targetText}`)
};

const fr_fr2_exercise_personal_goal_progress_label = /** @type {(inputs: Exercise_Personal_Goal_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Progression vers ${i?.targetText}`)
};

const de_de2_exercise_personal_goal_progress_label = /** @type {(inputs: Exercise_Personal_Goal_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fortschritt zu ${i?.targetText}`)
};

const it_it2_exercise_personal_goal_progress_label = /** @type {(inputs: Exercise_Personal_Goal_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Progresso verso ${i?.targetText}`)
};

/**
* | output |
* | --- |
* | "Progress toward {targetText}" |
*
* @param {Exercise_Personal_Goal_Progress_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_progress_label = /** @type {((inputs: Exercise_Personal_Goal_Progress_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_Progress_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_progress_label(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_progress_label(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_progress_label(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_progress_label(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_progress_label(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_progress_label(inputs)
	return en_us2_exercise_personal_goal_progress_label(inputs)
});
export { exercise_personal_goal_progress_label as "exercise-personal.goal_progress_label" }